import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { defer, forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EmploymentRecordGrievance } from './models/employment-record-grievance.model';
import { EmploymentRecordGrievancesService } from './services/employment-record-grievances.service';
import { EmploymentRecordGrievanceDialogComponent } from './components/employment-record-grievance-dialog/employment-record-grievance-dialog.component';

@Component({
  selector: 'app-employment-record-grievance',
  templateUrl: './employment-record-grievance.component.html',
  styleUrls: ['./employment-record-grievance.component.scss']
})
export class EmploymentRecordGrievanceComponent implements OnInit {
  @Input() employeeId: string;
  @Input() employmentRecordId: string;
  public columns: any[] = [
    { field: "type", subField: "text", title: "Type", type: "navigation" },
    { field: "shortDescription", title: "Short Description" },
    { field: "date", title: "Date", type: "date" },
    { field: "filedBy", subField: "text", title: "filed By" },
    { field: "status", subField: "text", title: "Status" },
    { field: "finalResolution", subField: "text", title: "Final Resolution" },
  ];
  public bindingType: String = "array";
  public view: Observable<GridDataResult>;
  public gridData: any;
  public gridDataResult: GridDataResult;
  isLoading: boolean;
  pageSize: number = 5;
  skip: number = 0;

  constructor(
    private dialog: MatDialog,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    private employmentRecordGrievancesService: EmploymentRecordGrievancesService
  ) {}

  ngOnInit(): void {
    this.view = this.employmentRecordGrievancesService.getGrievances(this.employeeId, this.employmentRecordId);
    this.getGrievances();
  }

  getGrievances(): void {
    this.isLoading = true;

    this.employmentRecordGrievancesService.getGrievances(this.employeeId, this.employmentRecordId, this.pageSize, this.skip)
    .pipe(
        finalize(()=>{ this.isLoading = false; })
    )
    .subscribe(
      res => {
        this.gridDataResult = {
          data: res.grievances,
          total: res.pagination.TotalCount,
        }
        this.gridData = res.employmentRecords;
      }
    )
  }

  openEmploymentRecordGrievanceDialog(employmentRecordGrievance?: EmploymentRecordGrievance) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      employmentRecordId: this.employmentRecordId,
      employeeId: this.employeeId,
      GrievanceId: employmentRecordGrievance ? employmentRecordGrievance.id : null
    };

    const dialogRef = this.dialog.open(EmploymentRecordGrievanceDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data === true) {
          this.getGrievances();
        }
      }
    );
  }

  deleteEmploymentRecordGrievance(employmentRecordGrievanceIds: string[]) {
    const observables = employmentRecordGrievanceIds.map(selectedItem => defer(() => this.employmentRecordGrievancesService.deleteGrievance(this.employeeId, this.employmentRecordId, selectedItem)));

    this.overlayService.show();

    forkJoin(observables)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.getGrievances();
        this.snackbarService.openSnackBar('Deleted successfully', 'clear', 'success');
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.pageSize = event.take
    this.getGrievances();
  }

}

